// const CUSTOM_PRICE_API_URL = 'http://sitang.local.com'
const CUSTOM_PRICE_API_URL = '';
function formDataToJSON (form) {
	const formData = new FormData(form);
	const json = {};

	for (const [key, value] of formData.entries()) {
		// 如果 key 已存在，转为数组处理（支持同名字段）
		if (json.hasOwnProperty(key)) {
			if (Array.isArray(json[key])) {
				json[key].push(value);
			} else {
				json[key] = [json[key], value];
			}
		} else {
			json[key] = value;
		}
	}

	return json;
}
function waitForFormAndBind () {
	const selector = '.vopo-block form[action*="/cart/add"]';
	const form = document.querySelector(selector);
	if (form) {
		bindFormEvents(form);
		return;
	}

	// 使用 MutationObserver 等待 form 被插入
	const observer = new MutationObserver((mutations, obs) => {
		const form = document.querySelector(selector);
		if (form) {
			// console.log('obs disconnect')
			obs.disconnect();
			bindFormEvents(form);
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}

function bindFormEvents (form) {
	// console.log('form 已找到并绑定事件', form);

	const addCartForm = document.querySelector('form[action*="/cart/add"][data-custom-price="true"]');
	// console.log(addCartForm)
	if (!addCartForm) return;
	// form.addEventListener('input', (event) => {
	// //     console.log('输入变化:', event.target.name, event.target.value);
	// });
	form.addEventListener('change', (event) => {
		// console.log('选项/文件变化:', event.target.name, event.target.value);

		const productForm = event.target.closest('.product__info-main_content').querySelector('.shopify-block form[action*="/cart/add"]')
		// console.log(productForm)
		if (!productForm) return;
		calcPrice(addCartForm, productForm).then(res => {
			// console.log(111111111)
			// console.log(res)
		}).catch(err => {

			if (err?.status === 422) {
			}
			// console.log(err)
		})
	});

}
document.addEventListener('DOMContentLoaded', waitForFormAndBind)

async function calcPrice (form, productForm) {
	const variantId = form.id.value
	const productId = form['product-id'].value
	const formData = formDataToJSON(productForm)
	formData.variantId = variantId
	formData.productId = productId
	const config = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
		body: JSON.stringify(formData),
	}
	return fetch(`${CUSTOM_PRICE_API_URL}/shopify/calcPrice`, config)
		.then(res => {
			// console.log(res)
			if (!res.ok) {
				const priceDom = document.querySelectorAll('.price--product dd span.price-item')
				if (res.status === 422) {
					priceDom.forEach(function (e) {
						e.innerText = '$'
					})
				} else {
					priceDom.forEach(function (e) {
						e.innerText = 'price error'
					})
				}
				throw res;
			}
			return res.json()
		})
		.then(res => {
			if (!res?.data?.additional_price) {
				throw new Error('no price')
			}

			const AdditionalPriceInput = productForm.querySelector('input[name="properties[Additional Price]"]')
			// console.log(AdditionalPriceInput)
			if (!AdditionalPriceInput) {
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = 'properties[Additional Price]';  // 自定义属性名称
				input.value = 'Total | $' + res.data.additional_price; // 自定义属性的值
				productForm.appendChild(input);
			} else {
				AdditionalPriceInput.value = 'Total | $' + res.data.additional_price
			}

			const priceDom = document.querySelectorAll('.price--product dd span.price-item')
			priceDom.forEach(function (e) {
				e.innerText = '$' + res.data.final_price
			})

			return res
		})
}

// 拦截bcpo的点击事件，加购行为
document.addEventListener('click', async function (event) {
	// event.preventDefault(); // 阻止表单默认提交行为
	// event.stopImmediatePropagation(); //  阻止其它监听器执行
	// 从点击目标向上查找 button 或 submit 类型
	const target = event.target.closest('button, input[type="submit"]');
	if (!target) return;
	if (target.type !== 'submit') {
		return
	}

	// 查找按钮所在的 form
	const form = target.closest('form[action*="/cart/add"]');
	if (!form) return;

	const productForm = target.closest('.product__info-main_content').querySelector('.shopify-block form[action*="/cart/add"]')
	// console.log(target)
	console.log(productForm)
	if (!productForm) return;

	// 自定义校验
	// if (isSectionNull()) return;
	console.log(!productForm.checkValidity());
	// 表单自带验证
	if (!productForm.checkValidity()) return

	if (event.isTrusted) {
		try {
			event.preventDefault(); // 阻止默认的表单提交行为
			event.stopPropagation() // 阻止事件传播

			const sendFormData = new FormData()

			const formData = new FormData(form);
			const cartForm = Object.fromEntries(formData.entries());
			const productFormData = new FormData(productForm);
			for (const [key, value] of productFormData.entries()) {
				const input = productForm.querySelector(`[name="${key}"]`)
				let price = null
				switch (input.type) {
					case 'select-one':
						price = input.selectedOptions[0].dataset.price
						break;
					case 'radio':
						const checkedInput = productForm.querySelector(`[name="${key}"]:checked`)
						price = checkedInput.dataset.price
						break;
					case 'text':
						price = input.dataset.price
						break;
					default:
						break;
				}
				const match = key.match(/^properties\[(.+)\]$/)
				if (match) {
					if (price) {
						sendFormData.append(key, `${value} | $${price}`)
					} else {
						sendFormData.append(key, value)
					}
				}
			}
			sendFormData.append('id', cartForm.id);
			sendFormData.append('quantity', cartForm.quantity)
			await fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				body: sendFormData
			})
				.then(response => {
					//     console.log('response:')
					//     console.log(response)
					return response.json();
				})
				.then(data => {
					console.log('已加入购物车:', data);
					document.querySelector('cart-drawer').open();
					document.querySelector('cart-drawer-items').onCartDrawerUpdate();
					// 在这里你可以弹窗提示、更新购物车图标数量等
				})
				.catch((error) => {
					console.error('Error:', error);
					throw error
				});
		} catch (err) {
			console.error(err)
			const newClick = new MouseEvent('click', {
				bubbles: true,
				cancelable: true,
				view: window
			});
			event.target.dispatchEvent(newClick);
		}
	}

	// 仅拦截具有 data-custom-price="true" 的 form
	if (form.getAttribute('data-custom-price') !== 'true') return;

	/*
			if (event.isTrusted) {
					// console.log('自定义价格')
					event.stopPropagation() // 阻止事件传播

					calcPrice(form, productForm)
							.then(res => {
									// 创建一个新的点击事件
									const newClick = new MouseEvent('click', {
											bubbles: true,
											cancelable: true,
											view: window
									});

									// 用 dispatchEvent 人为重新触发点击（这次没有被拦截）
									event.target.dispatchEvent(newClick);
							})
							.catch(err => {
									if(err?.status === 422){
											// 创建一个新的点击事件
											const newClick = new MouseEvent('click', {
													bubbles: true,
													cancelable: true,
													view: window
											});

											// 用 dispatchEvent 人为重新触发点击（这次没有被拦截）
											event.target.dispatchEvent(newClick);
									}
							})
			} else {
					// console.log('JS 触发的点击');
			}
	*/


	// ✅ 在这里进行拦截处理
	// event.preventDefault(); // 阻止表单默认提交行为
	// event.stopPropagation() // 阻止事件传播
	// event.stopImmediatePropagation(); //  阻止其它监听器执行

	// // console.log('🛑 自定义加购拦截:', form, target);

	// 你可以在这里执行你自己的加购逻辑
	// submitFormData(form); 或 Ajax 提交等
}, true);

function createDraftOrder (button) {
	try {
		fetch('/cart.js')
			.then(response => response.json())
			.then(cart => {
				// console.log(cart) // 购物车对象
				// let hasCustomProduct = false
				// for (const item of cart.items) {
				//     if(item?.properties['Additional Price']){
				//         hasCustomProduct = true
				//         break;
				//     }
				// }
				// if(hasCustomProduct){
				try {
					cart.uuid = getSessionId()
				} catch (e) { }
				const body = JSON.stringify(cart)
				const config = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
					body: body
				}
				fetch(`${CUSTOM_PRICE_API_URL}/shopify/draftOrders/thehues`, config).then(res => {
					return res.json()
				}).then(res => {
					if (res?.data?.invoiceUrl) {
						location.href = res.data.invoiceUrl
					} else {
						throw new Error('order create fail')
					}
				})
				// } else {
				// event.target.submit();
				// }
			})
			.catch(error => {
				console.error('Error fetching cart:', error)
				if (button) {
					button.classList.remove('loading')
				}
			})

	} catch (error) {
		console.error('Error during form validation:', error);
		alert('An error occurred. Please try again.');
	}
}

function isSectionNull () {
	$('.selector-wrapper').removeClass('emptyInput');
	$.each($('.selector-wrapper'), function (i, item) {
		if ($(item).find('.selectInput').length > 0) {
			const eventItem = $(item).find('.selectInput');
			const selectName = eventItem.attr('data-name').toLowerCase();
			if (selectName.includes('panel')) {
				if (eventItem.val() == '') {
					$(item).addClass('emptyInput');
				}
			}
		}
		if ($(item).find('select').length > 0) {
			const eventItem = $(item).find('select');
			const selectName = eventItem.attr('name').toLowerCase();
			if (selectName.includes('panel')) {
				if (eventItem.val() == null) {
					console.log(eventItem.val());
					$(item).addClass('emptyInput');
				}
			}
		}
		if ($(item).css('display') != 'none' && $(item).find('.hasItem').length == 0) {
			if ($(item).find('input[type="radio"]:not([name*=1])').length > 0) {
				if ($(item).find('input:checked').length == 0 && $(item).find('input').attr('name') != 'properties[Fabric]') {
					$(item).addClass('emptyInput');
				}
			}
			if ($(item).find('input[type="number"]').length > 0) {
				if ($(item).find('input[type="number"]').val().length == 0 || $(item).find('input[type="number"]').val() == 0) {
					$(item).addClass('emptyInput');
				}
			}
		}
	});
	if ($('.emptyInput').length > 0) {
		windowScrollTop($('.emptyInput'), ["header.header", '.productInfoTitle']);
		return true;
	} else {
		return false;
	}
}

document.addEventListener('click', async function (event) {
	const button = event.target.closest('button[name="checkout"]');
	if (button) {
		// console.log('stopPropagation 1')
		event.preventDefault(); // 阻止默认的表单提交行为
		event.stopPropagation() // 阻止事件传播
		if (!button.classList.contains('loading')) {
			button.classList.add('loading')
			createDraftOrder(button)
		}
	}


}, true);

// 表单提交操作
document.addEventListener('submit', async function (event) {
	// console.log(11111111111)
	// console.log(event.target)

	// 如果是添加到购物车
	if (0 && event.target && event.target?.attributes?.action?.value === '/cart/add') {
		event.preventDefault(); // 阻止默认的表单提交行为
		event.stopPropagation() // 阻止事件传播
		const variantId = event.target.id.value
		const productId = event.target['product-id'].value
		const formData = {
			productId: productId,
			variantId: variantId,
		};
		const config = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
			body: JSON.stringify(formData),
		}
		fetch(`${CUSTOM_PRICE_API_URL}/shopify/calcPrice`, config).then(res => {
			return res.json()
		}).then(res => {
			// console.log(res)
			// 判断是否自定义价格

			// 添加到购物车
			// const cartData = {
			//     'items': [{
			//         'id': variantId,
			//         'quantity': 1,
			//         'properties':{
			//             price: 100
			//         }
			//     }]
			// }
			// fetch(window.Shopify.routes.root + 'cart/add.js', {
			//     method: 'POST',
			//     headers: {
			//         'Content-Type': 'application/json'
			//     },
			//     body: JSON.stringify(cartData)
			// })
			// .then(response => {
			// //     console.log('response:')
			// //     console.log(response)
			//     return response.json();
			// })
			// .catch((error) => {
			//     console.error('Error:', error);
			// });

			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = 'properties[price]';  // 自定义属性名称
			input.value = 120; // 自定义属性的值
			event.target.appendChild(input);
			event.target.submit();

		})
	}

	const button = event.submitter;
	// 购物车提交下单
	if (button && button.name === 'checkout') {
		// console.log('stopPropagation 2')
		event.preventDefault(); // 阻止默认的表单提交行为
		createDraftOrder()
	}

}, true);
